import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../utils/api';
import './LoginPage.css';

const ZIRVE_LOGO = 'https://musterideneyimizirvesi.com/images/zirve-logo.jpg';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('mdz_token');
    if (token) navigate('/moderator');
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await login(username, password);
      localStorage.setItem('mdz_token', res.data.token);
      navigate('/moderator');
    } catch (err) {
      setError(err.response?.data?.error || 'Giriş başarısız. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <img src={ZIRVE_LOGO} alt="Müşteri Deneyimi Zirvesi" className="login-zirve-logo" />
          <div className="login-subtitle">Moderatör Girişi</div>
        </div>

        <form onSubmit={handleLogin} className="login-form">
          <div className="field">
            <label htmlFor="username">Kullanıcı Adı</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="moderator"
              autoComplete="username"
              disabled={loading}
            />
          </div>
          <div className="field">
            <label htmlFor="password">Şifre</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
              disabled={loading}
            />
          </div>
          {error && <div className="login-error">{error}</div>}
          <button type="submit" className="btn-login" disabled={loading || !username || !password}>
            {loading ? <span className="spinner" /> : 'Giriş Yap'}
          </button>
        </form>

        <div className="login-footer">
          <span>
            Powered by{' '}
            <a
              href="https://cloud4feed.com"
              target="_blank"
              rel="noopener noreferrer"
              className="c4f-link"
            >
              Cloud4Feed
            </a>
          </span>
        </div>
      </div>
    </div>
  );
}
